// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__63R2m","child1":"style_child1__tC89q","child2":"style_child2__B-A5e"};